import { ChangeEvent } from 'react'
import styled from '@emotion/styled'

type TextBoxProps = {
  value?: string
  width?: string
  disabled?: boolean
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
}

const Content = styled.input`
  border: 1px solid rgba(0, 0, 0, 0);
  margin: 0.5rem;
  padding: 0.5rem;
  width: 100%;
  border-radius: 2px 2px 2px 2px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  &:focus{
    background-color: #DBD5E5;
    outline: none;
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
`

export function Textbox({ onChange, value, width, disabled }: TextBoxProps) {
  return <Content
    onChange={onChange}
    value={value}
    style={{ width: width }}
    disabled={disabled}
  />
}
